// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Tonp","title":"Header_title__3cDP1","left":"Header_left__G-UeQ","clinicName":"Header_clinicName__3vFWq"};